/** Earnings estimate for paid drops (CAD). */

import { resolveCreatorFeeRate } from "./feeLadder";

const STRIPE_PERCENT = 0.029;
const STRIPE_FIXED = 0.30;

/** Live fee from locked ladder (founding / referral thresholds / cohort windows). */
export function getPlatformFeeRate(userProfile = {}) {
  const resolved = resolveCreatorFeeRate({
    foundingCreator: Boolean(
      userProfile.isFoundingContributor ||
        userProfile.foundingCreator ||
        userProfile.isFoundingMember
    ),
    lifetimeCreatorReferrals: userProfile.lifetimeCreatorReferrals || 0,
    cohort:
      userProfile.feeCohort ||
      (userProfile.feeTier === "earlywave" ? "earlywave" : userProfile.referredBy ? "referred" : "standard"),
    firstDropAt: userProfile.firstDropAt || null,
  });
  return resolved.feeRate;
}

export function isFoundingCreator(userProfile = {}) {
  return Boolean(
    userProfile.isFoundingContributor ||
    userProfile.foundingCreator ||
    userProfile.isFoundingMember
  );
}

export function calculateCreatorReceive(priceCad, userProfile = {}) {
  const price = Math.max(0, Number(priceCad) || 0);
  if (price <= 0) return { net: 0, label: "Free drop — no revenue" };

  const platformRate = getPlatformFeeRate(userProfile);
  const afterPlatform = price * (1 - platformRate);
  const afterStripe = Math.max(0, afterPlatform - price * STRIPE_PERCENT - STRIPE_FIXED);

  return {
    net: afterStripe,
    label: `~$${afterStripe.toFixed(2)} (after ${Math.round(platformRate * 100)}% fee + Stripe)`,
    platformRate,
    isFounding: isFoundingCreator(userProfile),
  };
}

export const TIER_ACCESS_OPTIONS = [
  { id: "everyone", label: "Everyone — regular drop", desc: "Appears in Gallery and Home feed. All 100 spots open equally to subscribers and non-subscribers. First come first served — no exceptions.", wide: true },
  { id: "tier1_plus", label: "Tier 1 and above", desc: "All subscribers" },
  { id: "tier2_plus", label: "Tier 2 and above", desc: "Mid + top tier only" },
  { id: "tier3_only", label: "Tier 3 only", desc: "Superfans only" },
  { id: "tier1_only", label: "Tier 1 only", desc: "Exclusively for Tier 1" },
  { id: "tier2_only", label: "Tier 2 only", desc: "Exclusively for Tier 2" },
];

export function tierAccessLabel(id) {
  return TIER_ACCESS_OPTIONS.find((o) => o.id === id)?.label || "Everyone";
}

export function afterCloseLabel(id) {
  if (id === "paid_archive") return "Paid archive";
  return "Gone forever";
}

export function contentTypeSummary(contentType, fileName) {
  const map = { video: "Video", photo: "Photo", audio: "Audio", article: "Article" };
  const base = map[contentType] || "Drop";
  if (fileName) return `${base} · ${fileName.split(".").pop()?.toUpperCase() || "file"}`;
  return base;
}
